/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * 
 */
export class MonitorApi extends runtime.BaseAPI {

    /**
     * Monitoring endpoint for poststart.sh, readiness and liveliness probe
     * Monitoring endpoint for poststart.sh
     */
    async getMonitorRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/monitor`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Monitoring endpoint for poststart.sh, readiness and liveliness probe
     * Monitoring endpoint for poststart.sh
     */
    async getMonitor(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getMonitorRaw(initOverrides);
        return await response.value();
    }

}
